import React,{Component} from 'react'
import '../../style/navbar.css'
import {Link} from 'react-router-dom'
class Navbar extends Component{
    render(){
        return(
            <div className="navbar">
                 <Link to="/profile" className="navdiv">
                     Profile
                 </Link>
                 <Link to="/about" className="navdiv">
                    About me
                 </Link>
                 <Link to="/works" className="navdiv">
                    Works
                 </Link>
                 <Link to="/contact" className="navdiv">
                    Contact
                 </Link>
            </div>
        )
    }
}

export default Navbar